import { TExperimentsState } from '../../types/experiment';
import { getExperiment } from './getExperiment';

export function isExperimentActive(experiments: TExperimentsState, experimentName: string, groupName: string): boolean {
  const experiment = getExperiment(experiments, experimentName);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === groupName;
}
